import React, { useState } from 'react';

const YouTubeCard = ({ url, isShort = false, itemLecture }) => {

  const [showIframe, setShowIframe] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const extractVideoId = (url) => {
    const match = url.match(/(?:\/shorts\/|v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };

  const videoId = extractVideoId(url);
  if (!videoId) return <p>Invalid YouTube URL</p>;

  // Alterna entre reproducir y detener el video
  const handleClick = () => {
    setShowIframe(!showIframe);
  };

  return (
    <div
      className="flex-none w-full p-2"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="relative overflow-hidden rounded-lg shadow-lg"
        style={{ aspectRatio: isShort ? '9/16' : '16/9' }}
      >
        {/* Botón "Aprendo" que aparece al hacer hover */}
        {isHovered && itemLecture && (
          <a
            href={`/lecturas/vp/${itemLecture.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute top-2 right-2 z-20 px-4 py-2 bg-green-500 text-white rounded-lg shadow-md hover:bg-green-600 transition-colors duration-300"
          >
            Aprendo
          </a>
        )}

        {showIframe ? (
          <>
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1`}
              className="absolute top-0 left-0 w-full h-full border-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video"
              loading="lazy"
            ></iframe>
            {/* Overlay con botón de pausa */}
            <div
              className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-transparent"
              onClick={handleClick}
            >
              <button className="z-5 text-white text-4xl bg-black bg-opacity-50 rounded-full p-4">
                ❚❚
              </button>
            </div>
          </>
        ) : (
          <div
            className="absolute top-0 left-0 w-full h-full cursor-pointer"
            onClick={handleClick}
          >
            <img
              src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
              alt="Video thumbnail"
              className="w-full h-full object-cover"
            />
            {/* Overlay sin fondo para que se vea la imagen de miniatura */}
            <div className="absolute inset-0 flex items-center justify-center">
              <button
                onClick={handleClick}
                className="z-5 text-white text-4xl bg-black bg-opacity-50 rounded-full p-4"
              >
                ▶
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YouTubeCard;
